'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _metrixCommon = require('metrix-common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WorkflowMapviewDynamic = function WorkflowMapviewDynamic(props) {
    var returnProp = props.return;


    var getAddress = function getAddress(elements) {
        var address = {};
        if (elements) {
            address.code = (0, _metrixCommon.getElementValueByCode)(elements, 'Code');
            address.apartmentSuite = (0, _metrixCommon.getElementValueByCode)(elements, 'ApartmentSuite');
            address.streetNumber = (0, _metrixCommon.getElementValueByCode)(elements, 'StreetNumber');
            address.street = (0, _metrixCommon.getElementValueByCode)(elements, 'Street');
            address.municipality = (0, _metrixCommon.getElementValueByCode)(elements, 'Municipality');
            address.state = (0, _metrixCommon.getElementValueByCode)(elements, 'State');
            address.stateCode = (0, _metrixCommon.getElementValueByCode)(elements, 'StateCode');
            address.country = (0, _metrixCommon.getElementValueByCode)(elements, 'Country');
            address.countryCode = (0, _metrixCommon.getElementValueByCode)(elements, 'CountryCode');
            address.postalCode = (0, _metrixCommon.getElementValueByCode)(elements, 'PostalCode');
            address.formattedAddress = (0, _metrixCommon.getElementValueByCode)(elements, 'FormattedAddress');
            address.description = (0, _metrixCommon.getElementValueByCode)(elements, 'Description');
            address.location = {};
            address.location.latitude = (0, _metrixCommon.getElementValueByCode)(elements, 'Latitude');
            address.location.longitude = (0, _metrixCommon.getElementValueByCode)(elements, 'Longitude');
        }
        return address;
    };

    var address = void 0;
    if (returnProp && returnProp.elements) address = getAddress(returnProp.elements);

    return _react2.default.createElement(
        _metrixCommon.Container,
        null,
        _react2.default.createElement(_metrixCommon.MapviewDynamic, _extends({}, props, { address: address }))
    );
};

WorkflowMapviewDynamic.propTypes = {
    return: _propTypes2.default.object
};

exports.default = WorkflowMapviewDynamic;